module.exports = __webpack_public_path__ + "img/jujueshouquan.21995a0f.png";